import React from 'react';
import { makeStyles } from '@fluentui/react-components';

type StatusType =
  | 'active' | 'ACTIVE'
  | 'inactive' | 'INACTIVE'
  | 'pending' | 'PENDING'
  | 'draft'
  | 'archived'
  | 'assigned' | 'ASSIGNED'
  | 'in_progress' | 'IN_PROGRESS'
  | 'completed' | 'COMPLETED'
  | 'overdue' | 'OVERDUE'
  | 'success' | 'warning' | 'danger' | 'info'
  | string;

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
}

const statusConfig: Record<string, { bg: string; color: string }> = {
  active: { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  completed: { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  success: { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  in_progress: { bg: '#E0F2FE', color: 'var(--undp-primary)' },
  assigned: { bg: '#E0F2FE', color: 'var(--undp-primary)' },
  info: { bg: '#E0F2FE', color: 'var(--undp-primary)' },
  draft: { bg: 'var(--color-warning-light)', color: '#946800' },
  pending: { bg: 'var(--color-warning-light)', color: '#946800' },
  warning: { bg: 'var(--color-warning-light)', color: '#946800' },
  inactive: { bg: '#F0F0F1', color: 'var(--color-text-tertiary)' },
  archived: { bg: '#F0F0F1', color: 'var(--color-text-tertiary)' },
  overdue: { bg: 'var(--color-error-light)', color: 'var(--color-error)' },
  danger: { bg: 'var(--color-error-light)', color: 'var(--color-error)' },
};

function getConfig(status: string) {
  const normalized = status.toLowerCase().replace(/ /g, '_');
  return statusConfig[normalized] || { bg: '#F0F0F1', color: 'var(--color-text-secondary)' };
}

const useStyles = makeStyles({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '3px 10px',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '1.4',
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
  },
});

export default function StatusBadge({ status, label }: StatusBadgeProps) {
  const s = useStyles();
  const config = getConfig(status);
  const displayText = label || status.replace(/_/g, ' ');

  return (
    <span
      className={s.badge}
      style={{ backgroundColor: config.bg, color: config.color }}
    >
      {displayText}
    </span>
  );
}
